// // CertificateUtils.ts
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import ReactDOM from 'react-dom/client';
// import React from 'react';
// import CertificateTemplate from './CertificateTemplate';

// export interface CertificateData {
//   certificateNumber: string;
//   unitType: string;
//   unitHolder: string;
//   units: number;
//   price: number;
//   date: string;
//   beneficiary: string;
//   trustee: string;
//   action: 'certificate' | 'application';
//   dateOfRegistration: string;
//   executionDate: string;
//   trustName: string;
//   trustDeedExecutionDate: string;
//   trustFundManagerSignatureBase64?: string | null;
//   investorSignatureBase64?: string | null;
// }

// // Critical: Preload all images (especially base64 signatures)
// const preloadImages = (container: HTMLElement): Promise<void> => {
//   const images = container.querySelectorAll('img');
//   const promises = Array.from(images).map((img) => {
//     return new Promise<void>((resolve) => {
//       if (img.complete && img.naturalHeight !== 0) {
//         resolve();
//         return;
//       }

//       const handleLoad = () => {
//         img.onload = null;
//         img.onerror = null;
//         resolve();
//       };

//       img.onload = handleLoad;
//       img.onerror = handleLoad; // Even on error, continue

//       // Force reload for data URLs
//       if (img.src.startsWith('data:')) {
//         img.src = img.src;
//       }
//     });
//   });

//   return Promise.all(promises).then(() => {});
// };

// const renderCertificateToCanvas = async (cert: CertificateData): Promise<string> => {
//   const container = document.createElement('div');
//   container.style.position = 'fixed';
//   container.style.left = '-9999px';
//   container.style.top = '-9999px';
//   container.style.width = '210mm';
//   container.style.minHeight = '297mm';
//   container.style.background = '#ffffff';
//   container.style.margin = '0';
//   container.style.padding = '0';
//   document.body.appendChild(container);

//   const root = ReactDOM.createRoot(container);
//   root.render(<CertificateTemplate {...cert} />);

//   return new Promise<string>((resolve, reject) => {
//     setTimeout(async () => {
//       try {
//         // Wait for React render
//         await new Promise((r) => setTimeout(r, 100));

//         // Critical: Wait for ALL images (signatures) to load
//         await preloadImages(container);

//         const canvas = await html2canvas(container, {
//           scale: 3, // Higher quality
//           useCORS: true,
//           allowTaint: true,
//           backgroundColor: '#ffffff',
//           width: 794, // 210mm × 3.78 ≈ 794px
//           height: 1123, // 297mm × 3.78 ≈ 1123px
//           windowWidth: 794,
//           windowHeight: 1123,
//           x: 0,
//           y: 0,
//           scrollX: 0,
//           scrollY: 0,
//           logging: false
//         });

//         const imgData = canvas.toDataURL('image/png', 1.0);

//         root.unmount();
//         document.body.removeChild(container);

//         resolve(imgData);
//       } catch (err) {
//         root.unmount();
//         if (container.parentNode) document.body.removeChild(container);
//         reject(err);
//       }
//     }, 500); // Increased delay for full render
//   });
// };

// // DOWNLOAD PDF – FIXED CUTTING & SIGNATURES
// export const generateCertificatePdfStyled = async (cert: CertificateData): Promise<void> => {
//   try {
//     const imgData = await renderCertificateToCanvas(cert);

//     const pdf = new jsPDF({
//       orientation: 'portrait',
//       unit: 'mm',
//       format: 'a4',
//       compress: true
//     });

//     // Exact A4 size
//     const width = pdf.internal.pageSize.getWidth(); // 210
//     const height = pdf.internal.pageSize.getHeight(); // 297

//     pdf.addImage(
//       imgData,
//       'PNG',
//       0,
//       0,
//       width,
//       height,
//       undefined,
//       'SLOW' // Best quality
//     );

//     const fileName = `${cert.unitHolder.replace(/[^a-zA-Z0-9]/g, '_')}_${
//       cert.unitType
//     }_Certificate.pdf`;
//     pdf.save(fileName);
//   } catch (error) {
//     console.error('PDF generation failed:', error);
//     alert('Failed to download PDF. Please try again.');
//   }
// };

// // For email
// // export const generateCertificatePdfBase64Raw = async (cert: CertificateData): Promise<string> => {
// //   const imgData = await renderCertificateToCanvas(cert);
// //   const pdf = new jsPDF('p', 'mm', 'a4');
// //   pdf.addImage(imgData, 'PNG', 0, 0, 210, 297, undefined, 'SLOW');
// //   return pdf.output('datauristring').split(',')[1];
// // };

// export const generateCertificatePdfBase64Raw = async (data: CertificateData): Promise<string> => {
//   const input = document.getElementById('certificate-print-area');
//   if (!input) throw new Error('Certificate element not found');

//   // Add small delay to ensure rendering
//   await new Promise((resolve) => setTimeout(resolve, 100));

//   const canvas = await html2canvas(input, {
//     scale: 2,
//     useCORS: true,
//     logging: false
//   });

//   const imgData = canvas.toDataURL('image/png');
//   const pdf = new jsPDF('p', 'mm', 'a4');
//   const width = pdf.internal.pageSize.getWidth();
//   const height = pdf.internal.pageSize.getHeight();
//   pdf.addImage(imgData, 'PNG', 0, 0, width, height);

//   return pdf.output('datauribase64');
// };

// src/components/fundManagement/certificate/CertificateUtils.tsx
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import React from 'react';
import ReactDOM from 'react-dom/client';
import CertificateTemplate from './CertificateTemplate';

export interface CertificateData {
  certificateNumber: string;
  unitType: string;
  unitHolder: string;
  units: number;
  price: number;
  date: string;
  beneficiary: string;
  trustee: string;
  action: 'certificate' | 'application';
  dateOfRegistration: string;
  executionDate: string;
  trustName: string;
  trustDeedExecutionDate: string;
  trustFundManagerSignatureBase64?: string | null;
  investorSignatureBase64?: string | null;
}

// OFF-SCREEN RENDERING — WORKS FOR BULK EMAIL 100%
const renderOffscreen = async (data: CertificateData): Promise<string> => {
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.left = '-9999px';
  container.style.top = '-9999px';
  container.style.width = '210mm';
  container.style.minHeight = '297mm';
  container.style.background = 'white';
  container.style.padding = '0';
  container.style.margin = '0';
  container.style.fontFamily = 'Arial, sans-serif';
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(<CertificateTemplate {...data} />);

  return new Promise<string>((resolve, reject) => {
    setTimeout(async () => {
      try {
        // Wait for images (signatures) to load
        const images = container.querySelectorAll('img');
        await Promise.all(
          Array.from(images).map((img) =>
            img.complete
              ? Promise.resolve()
              : new Promise((res) => {
                  img.onload = res;
                  img.onerror = res;
                })
          )
        );

        const canvas = await html2canvas(container, {
          scale: 2.5,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff',
          width: 794,
          height: 1123,
          logging: false
        });

        const imgData = canvas.toDataURL('image/png');

        root.unmount();
        document.body.removeChild(container);

        resolve(imgData);
      } catch (err) {
        root.unmount();
        if (container.parentNode) document.body.removeChild(container);
        reject(err);
      }
    }, 600);
  });
};

// FINAL WORKING: For bulk email — NO dependency on viewer
export const generateCertificatePdfBase64Raw = async (data: CertificateData): Promise<string> => {
  try {
    const imgData = await renderOffscreen(data);

    const pdf = new jsPDF('p', 'mm', 'a4');
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, 'PNG', 0, 0, width, height, undefined, 'SLOW');

    const dataUrl = pdf.output('dataurlstring');
    const base64 = dataUrl.split(',')[1];

    if (!base64 || base64.length < 50000) {
      throw new Error('Generated PDF is too small');
    }

    return base64;
  } catch (err) {
    console.error('PDF generation failed:', err);
    throw err;
  }
};

// For download — still works perfectly
export const generateCertificatePdfStyled = async (cert: CertificateData): Promise<void> => {
  try {
    const base64 = await generateCertificatePdfBase64Raw(cert);
    const binary = atob(base64);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    const blob = new Blob([new Uint8Array(array)], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${cert.unitHolder.replace(/[^a-zA-Z0-9]/g, '_')}_${
      cert.unitType
    }_Certificate.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    alert('Download failed. Please try again.');
  }
};
